// Global mixin: when a <keep-alive> page is re-entered, its `created`/`mounted` hooks do NOT
// run again, so a cached list would show stale rows after the user creates/edits a record
// elsewhere and comes back. Any cached page that auto-loads data should define
// `refreshOnActivate()` (re-fetch using the component's current page/sort/filter state) and
// this hook calls it whenever the page is re-entered — keeping table state preserved AND the
// data fresh.
//
// `activated` also fires once right after the initial mount, so we skip that first call
// (created already loaded the data) and only refresh on genuine re-entry. `activated` never
// fires for components rendered outside <keep-alive>, so this is inert everywhere else.
export default {
  activated() {
    if (this.$_keepAliveActivated && typeof this.refreshOnActivate === 'function') {
      this.refreshOnActivate();
    }
    this.$_keepAliveActivated = true;
  },
};
